
/**
 * 
 * @param int[] momDays - array of ints representing days on which we deliver 0 = sun, 1 = mon etc. 
 * @param int minDeliveryDays - The number of minimum days for delivery.
 * @param str[] publicHolidays - array of dates (str) in YYYY-MM-DD format on which public holidays fall
 * @returns moment object with days we don't deliver
 */


/**
 * set a counter
 * While loop to check for first X business days:
 * 
 * check if we are on a public holiday. 
 *      If so, then continue;
 *      If not then do the weekend check
 * 
 *  If we are on sat, sun:
 *      check if we deliver on sat or sun.
 *      if we do, then add 1 to counter
 *      if not, then continue;
 * 
 *  Otherwise, the day is valid ie weekday, not public holiday.
 *      If the day is valid, then add 1 to the counter
 *     
 * 
 */
async function setMom(momDays, minDeliveryDays, publicHolidays){
    // const momStart = moment().add(waitDays, 'days');
    const momStart = moment();//now
    const momEnd   = moment().add(DELIVERY_DAYS,'days');

    const momFormat = "dddd DD MMMM";
    

    let momResults = [];


    let momCurrent = momStart.clone();
    /**
     * Go through the moment object.
     * Find dates corresponding to days of the week on which we do not deliver.
     * Add those dates to the array.
     */

    let daysBufferCounter = 0;
    
    while(momCurrent.isSameOrBefore(momEnd)) {
        // console.log(daysBufferCounter);

        if(daysBufferCounter <= minDeliveryDays){  
            if(publicHolidays.includes(momCurrent.format('YYYY-MM-DD'))){
                // console.log("PUBLIC");
                momCurrent.add(1,'day');
                continue;
            }
            
            if (momCurrent.weekday() === 0 || momCurrent.weekday() === 6){
                //Do if we deliver on this day.
                if (momDays.includes(momCurrent.weekday())){
                    daysBufferCounter++;
                    // console.log("Adding " + momCurrent.format(momFormat));
                    momCurrent.add(1,'day');
                    continue;
                } else {
                    // console.log("No included add " + momCurrent.format(momFormat));
                    momCurrent.add(1,'day');
                    continue;
                }
            }
    
            //Need to perform more checks outside of min delivery days
            daysBufferCounter++;
            momCurrent.add(1,'day');
            continue;
        }
    
        //Only want the first available delivery date
        if(publicHolidays.includes(momCurrent.format('YYYY-MM-DD'))){
            // console.log("PUBLIC");
            momCurrent.add(1,'day');
            continue;
        }
    
    
        if (momCurrent.weekday() === 0 || momCurrent.weekday() === 6){
            //Do if we deliver on this day.
            if (momDays.includes(momCurrent.weekday())){
                momResults.push(momCurrent.clone().format(momFormat));
                momResults.push(momCurrent.clone().unix());
                break;
            } else {
                momCurrent.add(1,'day');
                continue;
            }
        }
    
        if (momDays.includes(momCurrent.weekday())){
            momResults.push(momCurrent.clone().format(momFormat));
            momResults.push(momCurrent.clone().unix());
            break;
        }
    
        momCurrent.add(1,'day');

    }

    return momResults;
}




